module.exports = __webpack_public_path__ + "media/images/icons/arrow_right-b576ca08d05577d1248e36e8557d2d94.svg";